import { Checkbox, FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateMoneyComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import styles from "./component_form_money.module.scss";

interface IComponentFormMoneyProps {
    component: ITemplateMoneyComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    onChange: (component: ITemplateComponent) => void;
    triggerValidate: number;
}

export const ComponentFormMoney: React.FC<IComponentFormMoneyProps> = React.memo(({
                                                                                      component,
                                                                                      enLanguageEnabled,
                                                                                      componentList,
                                                                                      triggerValidate,
                                                                                      onChange
                                                                                  }) => {
    const t = useComponentsTranslations();
    const { validateTag } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateMoneyComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>


        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       value={component.name ? component.name : ""}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       view="outline"/>
        </FormLabel>


        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>


        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />


        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                label={t("rowGroup")}
                size="m"
                onChange={() => onFieldChange({ isRowGroup: !component.isRowGroup })}
                checked={component.isRowGroup}
            />
        </div>

        {enLanguageEnabled && <Checkbox
            label={t("useEnValue")}
            size="m"
            onChange={() => onFieldChange({ useEnValue: !component.useEnValue })}
            checked={!!component.useEnValue}
        />}


        <div className={styles.textInputGroup}>
            <FormLabel title={t("minimumValue")} className={styles.groupedInput}>
                <Textinput size="m"
                           type="number"
                           value={component.minNumber ? component.minNumber : ""}
                           onChange={(e) => onFieldChange({ minNumber: e.target.value })}
                           view="outline"/>
            </FormLabel>
            <FormLabel title={t("maximumValue")} className={styles.groupedInput}>
                <Textinput size="m"
                           type="number"
                           value={component.maxNumber ? component.maxNumber : ""}
                           onChange={(e) => onFieldChange({ maxNumber: e.target.value })}
                           view="outline"/>
            </FormLabel>
        </div>

    </div>;
});

